import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

import styles from "../../../../assets/styles/componentStyles/organizationTeamsStyles/teams.module.scss";

import { UserContext, UserContextPayload } from "../../../../context/userContext";
import { GenericDataContext, GenericDataContextPayload } from "../../../../context/genericDataContext";
import { useOrganizationTeamsStore } from "../../../../store/organizationTeamsStore";
import { dashboardBreadcrumb, organizationTeamsBreadcrumb } from "../../../../utils/breadcrumb";

import TeamDetails from "./components/teamDetails/index.teamDetails";
import TeamsHeader from "./components/teamsHeader";
import Teams from "./components/teams";
import { Grid } from "@mui/material";

const OrganizationTeams = () => {

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { getOrganizationTeamsListApi, selectedTeam } = useOrganizationTeamsStore(
        useShallow((state) => ({
            getOrganizationTeamsListApi: state.getOrganizationTeamsListApi,
            selectedTeam: state.selectedTeam
        }))
    )

    const [searchParams] = useSearchParams();
    
    const organization_id = searchParams.get("organization_id");
    const team_id = searchParams.get("team_id");

    // Organization Teams List
    const getOrganizationTeamsListApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getOrganizationTeamsListApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if (!team_id) {
            getOrganizationTeamsListApiCall();
        }
    }, [team_id]);

    useEffect(() => {
        const teamsListPath = `/organization/teams?organization_id=${organization_id}`;

        const updatedBreadcrumb = [
            dashboardBreadcrumb,
            { ...organizationTeamsBreadcrumb, path: teamsListPath, isActive: !team_id },
            ...(team_id ? [{ name: selectedTeam?.organization_team_name ?? "Team Details", path: teamsListPath, isActive: true }] : []),
        ];
        
        setBreadCrumbs(updatedBreadcrumb);
    }, [team_id, organization_id, selectedTeam?.organization_team_name]);

    return (
        <>
            {!team_id ?
                <>
                    <Grid container className={styles.teamsPage}>
                        <TeamsHeader />
                        <Teams getOrganizationTeamsListApiCall={getOrganizationTeamsListApiCall} />
                    </Grid>
                </>
            :
                <TeamDetails />
            }
        </>
    )
}

export default OrganizationTeams;